<template>
  <div :class="`col-${width || 100}`">
    <span class="label">{{ label }}</span>
    <v-checkbox
      v-for="option in options"
      :key="option.id"
      v-model="selected"
      v-validate="validator"
      multiple
      data-vv-validate-on="change|input"
      :error-messages="errors.first(field)"
      :name="field"
      :value="option.value"
      :label="option.label"
      :disabled="disabled"
    >
    </v-checkbox>
  </div>
</template>
<script>
export default {
  name: 'FormCheckbox',
  inject: ['$validator'],
  props: {
    id: String,
    label: String,
    options: {
      type: Array,
      default: () => {}
    },
    width: {
      type: Number,
      default: 100
    },
    field: String,
    name: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    },
    extra_data: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    selected: []
  }),
  computed: {
    componentValue() {
      const obj = { [this.field]: this.selected }
      return this.extra_data ? { extra_data: obj } : obj
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-messages__message {
  padding-left: 12px;
  margin-bottom: 8px;
}
</style>
